import { render, staticRenderFns } from "./EmploymentAllowancesImportUncompleted.vue?vue&type=template&id=b6ea3322"
import script from "./EmploymentAllowancesImportUncompleted.vue?vue&type=script&lang=js"
export * from "./EmploymentAllowancesImportUncompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports